import React from 'react';
import { C } from '../../shared/design-tokens.js';
import { CONTROL_BUTTON } from './directory-ui.js';

interface DirectoryHeaderProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  backLabel?: string;
  actions?: React.ReactNode;
}

export default function DirectoryHeader({ title, subtitle, onBack, backLabel = 'Directory', actions = null }: DirectoryHeaderProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      {onBack ? (
        <button type="button" onClick={onBack} style={CONTROL_BUTTON}>
          ← {backLabel}
        </button>
      ) : null}
      <div style={{ flex: 1 }}>
        <div style={{ color: C.text, fontSize: 22, fontWeight: 700 }}>{title}</div>
        {subtitle ? <div style={{ color: C.textMuted, fontSize: 12, marginTop: 4 }}>{subtitle}</div> : null}
      </div>
      {actions}
    </div>
  );
}
